import _JSONBigint from "json-bigint";

const _BigJSON = _JSONBigint({ storeAsString: true });

const _parse = (
  data: string,
  reviver?: (this: any, key: string, value: any) => any
): any => {
  try {
    return JSON.parse(data, reviver);
  } catch (e) {
    console.debug("JSON.parse error ", e);
  }
  return {};
};

const parse = (
  data: string,
  reviver?: (this: any, key: string, value: any) => any
): any => {
  try {
    return _BigJSON.parse(data, reviver);
  } catch (_) {
    return _parse(data, reviver);
  }
};

const _stringify = (
  data: { key: string; value: any },
  replacer?: (this: any, key: string, value: any) => any,
  space?: string | number | undefined
): any => {
  try {
    return JSON.stringify(data, replacer, space);
  } catch (e) {
    console.debug("JSON.stringify error ", e);
  }
  return "";
};

const stringify = (
  data: { key: string; value: any },
  replacer?: (this: any, key: string, value: any) => any,
  space?: string | number | undefined
): any => {
  try {
    return _BigJSON.stringify(data, replacer, space);
  } catch (_) {
    return _stringify(data, replacer, space);
  }
};

export const isJSON = (v: any, options?: { strict?: boolean }) => {
  if (!!v && typeof v == "string") {
    if (!options?.strict) {
      return v.includes("{") && v.includes("}");
    }

    try {
      const obj = JSON.parse(v);
      return !!obj && typeof obj == "object";
    } catch (e) {
      return false;
    }
  }
  return false;
};

export const BigJSON = { parse, stringify, isJSON };
export default BigJSON;
